__turbopack_context__.v({
  "contentLayout": "layout-module__sqqsta__contentLayout",
  "logo": "layout-module__sqqsta__logo",
  "mainLayout": "layout-module__sqqsta__mainLayout",
  "mainSider": "layout-module__sqqsta__mainSider",
  "pageContent": "layout-module__sqqsta__pageContent",
  "toggleBtn": "layout-module__sqqsta__toggleBtn",
});
